/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface schema {
  email: string;
  permissions?: any;
}

const initialState = {
  email: "",
  permissions: {},
} as schema;

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<schema>) => {
      state.email = action.payload.email;
      state.permissions = action.payload.permissions;
    },
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
    setPermissions: (state, action: PayloadAction<any>) => {
      state.permissions = action.payload;
    },
    resetUser: () => initialState,
  },
});

export const { resetUser, setUser, setEmail, setPermissions } =
  userSlice.actions;

export const selectUser = (state: { user: schema }) => state.user;

export default userSlice.reducer;
